import {FormField, LabelInValue} from "../../../common/form";
import {ComplianceTicket} from "../../../__generated__/graphql/types";

type CTFields =
    '_id' |
    'completionDate' |
    'expirationDate' |
    "ticketTemplateDoc" |
    'didPass'

export type ComplianceTicketFormData = {
    internalId: ComplianceTicket['_id'],
    ticketTemplateIDAndName: FormField<LabelInValue>,
    result_passed: FormField<number>,
} & Pick<ComplianceTicket, CTFields>

type ExtractValueType<T> = T extends FormField<infer U> ? U : T;

export type ComplianceTicketFormValues = {
    [K in keyof ComplianceTicketFormData]: ExtractValueType<ComplianceTicketFormData[K]>
}

export enum VeriflytTicketFormFields {
    ticketTemplateIDAndName = 'ticketTemplateIDAndName',
    completionDate = 'completionDate',
    expirationDate = 'expirationDate',
    result_passed = 'result_passed'
}